var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"title":"我的资料"}},[_vm._v(" 我在资料 ")])}
var staticRenderFns = []

export { render, staticRenderFns }